<template>
  <div class="body-1 text-left pt-5 mb-5" :id="id">
    <v-icon color="primary" class="mr-2 ml-4" v-if="show_icon==true" >{{ icon }}</v-icon>
    <span v-html="title" v-if="title.length > 0"></span> <br v-if="title.length > 0" />
    <div :class="slot_div_class">
        <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "PlainDisplay",
  props: {
    id: {
      type: String,
      default: () => {
        return (
          "plain_display_" +
          Math.random() +
          "_" +
          (new Date()).getTime()
        );
      },
    },
    show_icon: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: "mdi-book-information-variant",
    },
    title: {
      type: String,
      default: ""
    },
  },
  computed:{
    slot_div_class(){
      var cls = "pl-10 ";
      cls = cls + (this.title.length > 0 ? " pt-10 " : "");
      return cls;
    }
  }
};
</script>